var map = {
	"./agTech.js": "0928",
	"./blockchain.js": "2651",
	"./dictionary.js": "f820",
	"./finance.js": "c18d",
	"./followRecord.js": "8e75",
	"./home.js": "1a2c",
	"./index.js": "c270",
	"./like.js": "1a5d",
	"./login.js": "783e",
	"./machineShare.js": "5ad5",
	"./messageBoard.js": "259f",
	"./myApply.js": "528d",
	"./news.js": "0e5c",
	"./personalCenter.js": "1ad5",
	"./region.js": "1649",
	"./supplyDemand.js": "59dc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f008";